import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAddProviderLanguages,
  fetchDeleteProviderLanguages,
  fetchLanguageSuggestions,
  fetchProviderLanguages,
} from "./ProviderLanguageActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const induvidualProviderLanguageList = createSlice({
  name: "induvidualProviderLang",
  initialState: {
    isLangLoading: false,
    langData: [],
    langError: null,
    lngErrorMsg: "",
  },
  reducers: {
    addProviderLanguage: (state, action) => {
      state.langData = action.payload;
    },
    deleteProviderLanguage: (state, action) => {
      const { displayId } = action.payload;
      const updatedLanguages = action.payload.langData.filter((langItem) => {
        return langItem.displayId !== displayId;
      });
      state.langData = updatedLanguages;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderLanguages.pending, (state) => {
        state.isLoading = true;
        state.langError = null;
      })
      .addCase(fetchProviderLanguages.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.langData = [];
            state.langError = false;
          } else {
            state.langError = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.langError = false;
          state.langData = action.payload.data.data.providerLanguageResponseDTO;
        }
      })
      .addCase(fetchProviderLanguages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchAddProviderLanguages.pending, (state) => {
        state.isLoading = true;
        state.langError = null;
      })
      .addCase(fetchAddProviderLanguages.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.langError = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.langError = false;
        }
      })
      .addCase(fetchAddProviderLanguages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchDeleteProviderLanguages.pending, (state) => {
        state.isLoading = true;
        state.langError = null;
      })
      .addCase(fetchDeleteProviderLanguages.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data?.metadata?.outcome?.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.langData = [];
            state.langError = false;
          } else {
            state.langError = true;
            state.lngErrorMsg = getApiErrorMessage(action.payload.status);
          }
        } else {
          state.langError = false;
          state.langData = action.payload.data.data.providerLanguageResponseDTO;
        }
      })
      .addCase(fetchDeleteProviderLanguages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

const providerLanguageSuggestions = createSlice({
  name: "langSuggestion",
  initialState: {
    isSuggesrionLoading: false,
    suggestionData: [],
    suggestionError: null,
    langSuggestionErrorMsg: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLanguageSuggestions.pending, (state) => {
        state.isSuggesrionLoading = true;
        state.error = null;
      })
      .addCase(fetchLanguageSuggestions.fulfilled, (state, action) => {
        state.isSuggesrionLoading = false;
        state.isLoading = false;
        if (action.payload.success) {
          state.suggestionError = false;
          state.suggestionData =
            action.payload?.data?.data?.languageResponseDTO.items;
        }
      })
      .addCase(fetchLanguageSuggestions.rejected, (state, action) => {
        state.isSuggesrionLoading = false;
        state.suggestionError = action.error.message;
      });
  },
});

export const { addProviderLanguage, deleteProviderLanguage } =
  induvidualProviderLanguageList.actions;
export const induvidualProviderLangReducer =
  induvidualProviderLanguageList.reducer;
export const languageSuggestionReducer = providerLanguageSuggestions.reducer;
